/**
 * Convert a major-unit currency amount to its smallest unit for stripe.
 *
 * Uses Intl.NumberFormat to resolve the correct number of decimal
 * places for the given ISO 4217 currency code.
 *
 * e.g. GBP 12.50 → 1250, JPY 1500 → 1500, BHD 5.123 → 5123
 */
export const toMinorUnits = (amount: number, currencyCode: string): number => {
  const decimals =
    new Intl.NumberFormat('en', {
      style: 'currency',
      currency: currencyCode,
    }).resolvedOptions().maximumFractionDigits ?? 2;

  return Math.round(amount * (10 ** decimals));
};
